import { render, staticRenderFns } from "./Lancamentos.vue?vue&type=template&id=04076210&scoped=true"
import script from "./Lancamentos.vue?vue&type=script&lang=js"
export * from "./Lancamentos.vue?vue&type=script&lang=js"
import style0 from "./Lancamentos.vue?vue&type=style&index=0&id=04076210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04076210",
  null
  
)

export default component.exports